module.exports = __webpack_public_path__ + "static/media/thum2.77ba7704.jpg";